import { useTheme } from '@material-ui/core/styles'
import { useCallback } from 'react'
import { createMuiTheme } from '@material-ui/core'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import useStyles from './PDFContainer.styled'
import { BORDER_WIDTH } from './PDFContainer.const'

export const usePDFContainer = ({ children, collection, active }) => {
	const metaData = useSectionMetaData()
	const classes = useStyles({ active })
	const { showBorders } = useTheme()
	const contentTheme = useCallback(parentTheme => {
		if (!parentTheme.showBorders) return parentTheme

		const theme = createMuiTheme(parentTheme)

		theme.margins = {
			top: BORDER_WIDTH,
			left: BORDER_WIDTH,
			bottom: BORDER_WIDTH,
			right: BORDER_WIDTH,
		}
		theme.overrides = {
			MuiContainer: {
				root: {
					paddingLeft: theme.spacing(BORDER_WIDTH),
					paddingRight: theme.spacing(BORDER_WIDTH),
					[theme.breakpoints.up('sm')]: {
						paddingLeft: theme.spacing(BORDER_WIDTH),
						paddingRight: theme.spacing(BORDER_WIDTH),
					},
				},
			},
		}
		return theme
	}, [])

	return [
		{
			classes,
			collection,
			showBorders,
			contentTheme,
			children,
			withBgImage: !!metaData.backgroundImage?.image,
			bgImage: metaData.backgroundImage,
			bgShading: metaData.backgroundShading?.toNumber(),
		},
	]
}
